export default function waitForElement(selector, callback, options) {
    var defaults = {
            allowedAttempts: 150,
            timeout: 200
        },
        opts = Object.assign({}, defaults, options),
        attempt = 1;

    function checkForElement() {
        var $element = document.querySelector(selector);

        if (attempt <= opts.allowedAttempts) {
            if ($element) {
                callback($element);
            } else {
                attempt++;
                setTimeout(checkForElement, opts.timeout);
            }
        }
    }

    checkForElement();
}

